import {useFormatCurrency, useFormatNumber} from 'platform/locale';

import {isNil} from 'ramda';

import {EMPTY_PLACEHOLDER, type Nullish} from 'shared/web';

import type {DailyStockTakeMoney} from '../utils/buildDailyStockTakeDetailView';

const MONEY_DECIMALS = 2;
const COUNT_DECIMALS = 0;

/**
 * One rendering rule for the amounts and counts of the daily stock take, shared by the dialog and
 * its breakdown sections so the two cannot drift apart.
 */
export function useDailyStockTakeFormatters() {
  const formatCurrency = useFormatCurrency();
  const formatNumber = useFormatNumber();

  const money = (amount: DailyStockTakeMoney | null) =>
    isNil(amount)
      ? EMPTY_PLACEHOLDER
      : (formatCurrency(amount.value, amount.currency, MONEY_DECIMALS) ?? EMPTY_PLACEHOLDER);

  const count = (value: number | Nullish) =>
    formatNumber(value, COUNT_DECIMALS) ?? EMPTY_PLACEHOLDER;

  return {money, count};
}
